<template>
  <div>
    <trac-loading v-if="isLoading" />
    <template>
      <trac-input
        placeholder="Modifier set name"
        class="mb-4"
        v-model="modifier.name"
      />
      <div
        v-for="(modifier, index) in modifier.modifiers"
        :key="index"
        class="grid grid-cols-12 gap-4 mb-4"
      >
        <div class="col-span-6">
          <trac-input v-model="modifier.name" placeholder="Modifier name" />
        </div>
        <div class="col-span-6 flex items-center gap-2">
          <trac-input
            v-model.number="modifier.selling_price"
            placeholder="₦ Modifier Price"
            type="number"
            class="flex-grow"
          />
          <button
            v-if="showDeleteModifierBtn"
            class="w-5"
            @click="deleteModifier(index)"
          >
            {{ modifier.modifiers && modifier.modifiers.length }}
            <img src="../../assets/svg/trash.svg" class="w-full" />
          </button>
        </div>
      </div>
      <trac-button
        class="text-primaryBlue text-sm font-bold mb-4"
        variant="plain"
        @button-clicked="modifier.modifiers.push({ ...newModifier })"
      >
        ADD NEW
      </trac-button>
      <div class="pt-5 border-t border-lightGray">
        <trac-button
          variant="outline"
          class="w-full"
          :disabled="!submitBtnActive"
          @button-clicked="saveModifierSet"
        >
          SAVE MODIFIER SET
        </trac-button>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { GET_USER_BUSINESS_DATA } from '../../browser-db-config/localStorage';
import { eventBus } from '../../eventBus';
const newModifier = { name: '', selling_price: null };

export default {
  name: 'CreateModifierSet',
  emits: ['close'],
  data() {
    return {
      modifier: {
        name: '',
        business_id: GET_USER_BUSINESS_DATA()._id,
        modifiers: [{ name: '', selling_price: 0 }],
      },
      newModifier,
      isLoading: false,
    };
  },
  computed: {
    submitBtnActive() {
      return (
        this.modifier.name &&
        this.modifier.modifiers.every(
          (m) => m.name && typeof m.selling_price === 'number'
        )
      );
    },
    showDeleteModifierBtn() {
      return this.modifier.modifiers.length > 1;
    },
  },
  methods: {
    ...mapActions(['CREATE_MODIFIER_SETS']),
    deleteModifier(index) {
      this.modifier.modifiers.splice(index, 1);
    },
    async saveModifierSet() {
      this.isLoading = true;
      try {
        const res = await this.CREATE_MODIFIER_SETS(this.modifier);
        if (res.status) {
          eventBus.$emit('trac-alert', {
            message: 'Modifier set created successfully',
          });
          this.$emit('close');
        }
      } catch (error) {
        eventBus.$emit('trac-alert', {
          message: error?.res?.data?.message || error?.message,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped></style>
